import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Grid,
  TableContainer,
} from '@mui/material';
import { useGetUserDetailsQuery } from '../services/users.endpoints';

interface UserDetailsTableProps {
  userId: string;
}

const UserDetailsTable = ({ userId }: UserDetailsTableProps) => {
  const { data: details } = useGetUserDetailsQuery(userId);

  // Define the same style object used in the Subscriptions component
  const tableStyles = {
    tableContainer: {
      marginBottom: '20px',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    tableHead: {
      backgroundColor: '#f5f5f5',
    },
    tableCell: {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      fontWeight: 'bold',
    },
  };

  return (
    <TableContainer component={Paper} sx={tableStyles.tableContainer}>
      <Table aria-label="user details table" size="small">
        <TableHead sx={tableStyles.tableHead}>
          <TableRow>
            <TableCell align="center" sx={tableStyles.tableCell}>
              NAME
            </TableCell>
            <TableCell align="center" sx={tableStyles.tableCell}>
              EMAIL
            </TableCell>
            <TableCell align="center" sx={tableStyles.tableCell}>
              ORGANIZATION
            </TableCell>
            <TableCell align="center" sx={tableStyles.tableCell}>
              CREATED
            </TableCell>
            <TableCell align="center" sx={tableStyles.tableCell}>
              LAST LOGIN
            </TableCell>
            {/* {isAdmin && (
              <>
                <TableCell align="center" sx={tableStyles.tableCell}>
                  TOTAL SPENT
                </TableCell>
                <TableCell align="center" sx={tableStyles.tableCell}>
                  TOTAL REFUNDED
                </TableCell>
              </>
            )} */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {details && (
              <>
                <TableCell align="center">
                  {details.user.firstName} {details.user.lastName}
                </TableCell>
                <TableCell align="center">{details.user.email}</TableCell>
                <TableCell align="center">
                  {details.user.organization}
                </TableCell>
                <TableCell align="center">
                  {new Date(details.user.createdAt).toLocaleString()}
                </TableCell>
                <TableCell align="center">
                  {details.user.lastLogin &&
                    new Date(details.user.lastLogin).toLocaleString()}
                </TableCell>
              </>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserDetailsTable;
